// removed by extract-text-webpack-plugin
module.exports = {"container":"LiveEventList__container__1JY54","showsExtraBets":"LiveEventList__showsExtraBets__Ki3TI","hidesExtraBets":"LiveEventList__hidesExtraBets__25sgZ","quickHidesExtraBets":"LiveEventList__quickHidesExtraBets__2M0g6"};


//////////////////
// WEBPACK FOOTER
// ./src/Containers/LiveEventList/LiveEventList.css
// module id = 521
// module chunks = 0